import { AnnouncementStatus } from '@/api/announcements/types';

export const Constants = {
  title: 'Comunicados',
  subtitle: 'Gerencie comunicados in-product para seus usuários',
  newAnnouncement: '+ Novo comunicado',
  onlyOneActive: 'Apenas um comunicado pode estar ativo por vez',
  emptyTable: 'Nenhum comunicado encontrado. Crie seu primeiro comunicado!',
  columnName: 'Nome',
  columnCards: 'Cards',
  columnCreatedAt: 'Data de criação',
  columnPublishedAt: 'Data de publicação',
  columnViewed: 'Visualizações',
  columnCompleted: 'Concluiram',
  columnStatus: 'Status',
  active: 'Ativo',
  createdAt: 'Criado em:',
  publishedAt: 'Publicado em:',
  cards: 'Cards:',
  preview: 'preview',
  edit: 'editar',
  remove: 'excluir',
  totalEligible: 'Total elegíveis',
  viewed: 'Visualizaram',
  completed: 'Concluíram',
  viewLater: 'Ver depois',
  notViewed: 'Não viram',
  metricsNote: 'Nota:',
  metricsNoteText:
    'As métricas são agregadas e não identificam usuários individualmente. ' +
    'Os dados são atualizados em tempo real conforme os usuários interagem ' +
    'com o comunicado.',
  metricsLegendTitle: 'Como os números se relacionam',
  metricsLegendEligible:
    'Total elegíveis = Visualizaram + Ver depois + Não viram.',
  metricsLegendCompleted:
    'Concluíram já está contado dentro de Visualizaram — é a parte de quem ' +
    'chegou até o último card.',
  notFound: 'Comunicado não encontrado.',
  deactivateMessage: (title: string): string =>
    `O comunicado "${title}" não será mais exibido para os usuários.`,
  activateMessage: (title: string): string =>
    `Ao ativar "${title}", ele será exibido para todos os usuários.`,
  publishMessage: (title: string): string =>
    `O comunicado "${title}" será exibido para todos os usuários ` +
    'ao acessarem a plataforma.',
  convertToDraftMessage: (title: string): string =>
    `O comunicado "${title}" será convertido para rascunho ` +
    'e não será mais exibido para os usuários.',
  deleteMessage: 'Você gostaria de excluir este comunicado?',
  deleteWarning: 'Atenção! Esta ação não poderá ser desfeita.',
  activeWillBeDeactivated: (title: string): string =>
    `Atenção! O comunicado ativo atual "${title}" será automaticamente desativado.`,
  cancel: 'cancelar',
  deactivate: 'desativar',
  activate: 'ativar',
  publish: 'publicar',
  convert: 'converter',
  confirmDelete: 'excluir',
  newTitle: 'Novo comunicado',
  editTitle: 'Editar comunicado',
  formSubtitle: 'Crie um novo comunicado para seus usuários',
  nameLabel: 'nome do comunicado*',
  nameHelper:
    'Nome interno para identificação. Não é exibido para os usuários.',
  cardsSection: 'Cards do comunicado',
  cardCount: (count: number): string =>
    count === 1 ? '1 card' : `${count} cards`,
  addCard: '+ adicionar card',
  cardLabel: (position: number): string => `Card ${position}`,
  cardTitleLabel: 'título do card*',
  cardDescriptionLabel: 'descrição do conteúdo do card*',
  cardOptional: 'opcional:',
  cardOptionalHelper:
    'Aqui você pode optar por incluir um vídeo ou uma imagem no card',
  videoLabel: 'link de vídeo',
  invalidVideoUrl:
    'Link de vídeo inválido. Use um link do YouTube (ex: youtube.com/watch?v=...).',
  imageLabel: 'imagem',
  imageRatioHelper:
    'Recomendamos imagens na resolução padrão de 640x360 (formato 16:9) — ' +
    'outras proporções serão cortadas para preencher o quadro.',
  gifNotAllowed:
    'Imagens em GIF não são permitidas. Envie uma imagem estática.',
  saveAsDraft: 'salvar como rascunho',
  publishAnnouncement: 'publicar comunicado',
  tips: 'Dicas:',
  tipDrag: 'Arraste os cards para ordená-los',
  tipLimit: 'Limite de 5 cards por comunicado',
  savedAsDraft: 'O comunicado foi salvo como rascunho',
  published: 'O comunicado foi publicado',
  deleted: 'O comunicado foi excluído',
  activated: 'O comunicado foi ativado',
  deactivated: 'O comunicado foi desativado',
  convertedToDraft: 'O comunicado foi salvo como rascunho',
  requiredName: 'Informe o nome do comunicado.',
  requiredCardFields: 'Preencha título e descrição de todos os cards.',
  requiredField: 'Campo obrigatório',
  maxCards: 'Limite de 5 cards por comunicado.',
  previewBadge: 'NOVIDADE',
  previewViewLater: 'ver depois',
  previewConfirm: 'OK, entendi',
  previewCounter: (current: number, total: number): string =>
    `${current} de ${total}`,
};

export const statusLabels: Record<AnnouncementStatus, string> = {
  active: 'Ativo',
  draft: 'Rascunho',
  inactive: 'Desativado',
};
